import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { AppStore, store } from ".";

export const store$ = new Observable<AppStore>((observer) => {
  store.subscribe(() => {
    observer.next(store.getState());
  });
}).pipe(shareReplay(1));
